// ignore-string-externalization

import React from 'react';
import styled from 'styled-components';
import {
  spacer40,
  screenSmMax,
  makeColorSetClass,
  cssColorValue,
  screenSmMin,
  screenXsMax,
  spacer16,
  spacer24,
} from '@spotify-internal/encore-web';
import { ModuleType } from '../types';
import { ContentfulAsset } from '../../Contentful';
import { FeaturedContentHeadline } from '../../ui';
import { TwoUpSegment } from './TwoUpSegment';
import { MODULE_COLOR_SETS } from '../../Theme';

const Wrapper = styled.div`
  background-color: ${cssColorValue('backgroundBase')};
  @media (max-width: ${screenXsMax}) {
    padding: ${spacer24} ${spacer16};
  }

  @media (min-width: ${screenSmMin}) {
    padding: ${spacer24} ${spacer40};
  }
`;

const TwoUp = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: ${screenXsMax}) {
    padding: ${spacer24} ${spacer16};
  }

  @media (min-width: ${screenSmMin}) {
    padding: ${spacer24} ${spacer40};
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
  }
`;

const Left = styled.div`
  width: 45%;
  padding-right: ${spacer40};

  @media (max-width: ${screenSmMax}) {
    padding-right: 0px;
    width: 100%;
  }
`;

const Right = styled.div`
  width: 45%;
  padding-left: ${spacer40};

  @media (max-width: ${screenSmMax}) {
    padding-left: 0px;
    width: 100%;
  }
`;

type TwoUpModuleType = ModuleType & {
  supertext?: string;
  headline?: string;
  image?: ContentfulAsset;
  caption?: string;
  segment1Headline?: string;
  segment1Body?: string;
  segment1LinkText?: string;
  segment1LinkUrl?: string;
  segment1Image?: ContentfulAsset;
  segment2Headline?: string;
  segment2Body?: string;
  segment2LinkText?: string;
  segment2LinkUrl?: string;
  segment2Image?: ContentfulAsset;
};

export const TwoUpModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  TwoUpModuleType
>(
  (
    {
      supertext = '',
      headline = '',
      image,
      caption = '',
      segment1Headline = '',
      segment1Body = '',
      segment1LinkText = '',
      segment1LinkUrl = '',
      segment1Image,
      segment2Headline = '',
      segment2Body = '',
      segment2LinkText = '',
      segment2LinkUrl = '',
      segment2Image,
      themeName,
    },
    ref,
  ) => {
    const fchProps = {
      supertext,
      headline,
      image,
      useFeaturedContentHeadline: true,
      caption,
    };
    const segment1 = {
      segmentHeadline: segment1Headline,
      segmentBody: segment1Body,
      segmentLinkText: segment1LinkText,
      segmentLinkUrl: segment1LinkUrl,
      segmentImage: segment1Image as ContentfulAsset,
    };
    const segment2 = {
      segmentHeadline: segment2Headline,
      segmentBody: segment2Body,
      segmentLinkText: segment2LinkText,
      segmentLinkUrl: segment2LinkUrl,
      segmentImage: segment2Image as ContentfulAsset,
    };

    return (
      <Wrapper
        className={makeColorSetClass(
          MODULE_COLOR_SETS[themeName || 'whiteOnBlack'],
        )}
      >
        <TwoUp ref={ref as React.RefObject<HTMLDivElement>}>
          <FeaturedContentHeadline {...fchProps} />
          <Bottom>
            <Left>
              <TwoUpSegment twoUpSegment={segment1} />
            </Left>
            <Right>
              <TwoUpSegment twoUpSegment={segment2} />
            </Right>
          </Bottom>
        </TwoUp>
      </Wrapper>
    );
  },
);
